export const data = [
  { img: "./html.svg", title: "HTML" },
  { img: "./css.svg", title: "CSS" },
  { img: "./tailwind-css.svg", title: "Tailwind-Css" },
  { img: "./javascript.svg", title: "JS" },
  { img: "./react.svg", title: "React" },
  { img: "./redux.svg", title: "Redux" },
  { img: "./nodejs.svg", title: "Node.js" },
  { img: "./expressjs.svg", title: "Express" },
  { img: "./mongodb.svg", title: "MongoDB" },
  { img: "./postman.svg", title: "Postman" },
  { img: "./prompt.png", title: "Prompt Engineering" },
];
